function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

export { getAltAxis as g };
//# sourceMappingURL=getAltAxis-Bdf0QLAP.js.map
